import { type GraphQLClient, createGraphqlClient } from "@package/graphql";
import { jwtDecode } from "jwt-decode";
import { logger } from "@artis/logger";

import { getArtisHeaders, getHasuraUrl, type JWT, orgIdToEnv } from "../../globals";

export const createHasuraClient = (_initialToken: string, getToken: () => Promise<string>): GraphQLClient => {
  const endpoint = getHasuraEndpoint(_initialToken);

  return createGraphqlClient(endpoint, async () => {
    const token = await getToken();
    try {
      const { exp, iat, sub } = jwtDecode<{ exp?: number; iat?: number; sub?: string }>(token);
      logger.info("Hasura getHeaders resolved", {
        tags: ["auth", "gql"],
        exp,
        iat,
        secs_to_exp: typeof exp === "number" ? exp - Math.floor(Date.now() / 1000) : null,
        user_id: sub,
      });
    } catch {}
    return {
      ...getArtisHeaders(token),
      authorization: `Bearer ${token}`,
    };
  });
};

export const getHasuraEndpoint = (token: string) => {
  const claims = token ? jwtDecode<JWT>(token) : undefined;
  if (!claims) throw new Error("No claims found in token");
  return getHasuraUrl(orgIdToEnv(claims.org_id));
};
